import axios from 'axios';
import { toast } from 'react-toastify';

export function multiCourseUsers(courseIds, searchTerm) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/multiCourseUsers', {
          courseIds,
          searchTerm,
        })
        .then((response) => {
          const data = response.data.courseUsers;

          return resolve(data);
        })
        .catch((error) => {
          toast('Error while getting course users. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function multiCourseStudentsReportByTopic(courseId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/multiCourseStudentsReportByTopic', {
          courseId,
        })
        .then((response) => {
          const data = response.data.studentsReportByTopic;

          return resolve(data);
        })
        .catch((error) => {
          toast('Error while getting report by topic. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function multiCourseStudentsReportByWeek(
  courseIds,
  reportType,
  schoolIds,
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/multiCourseStudentsReportByWeek', {
          courseIds,
          reportType,
          schoolIds,
        })
        .then((response) => {
          const data = response.data.studentsReportByWeek;

          return resolve(data);
        })
        .catch((error) => {
          toast('Error while getting report by week. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function refreshMultiCourseReport(report, eventData = {}) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/refreshMultiCourseReport', {
          report,
          ...eventData,
        })
        .then((response) => {
          toast(
            'We are regenerating this report. We will email you when it’s ready.',
            {
              type: 'success',
            },
          );

          return resolve();
        })
        .catch((error) => {
          toast('Error while refreshing report. Please try again.', {
            type: 'error',
          });

          return resolve();
        });
    });
  };
}

export function getCoursesAndSchoolsBySelection(schoolIds, courseIds) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/getCoursesAndSchoolsBySelection', {
          schoolIds,
          courseIds,
        })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          toast('Error while fetching courses and schools. Please try again.', {
            type: 'error',
          });

          return reject();
        });
    });
  };
}

export function getCoursesSummaryReport(schoolIds, courseIds) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/getCoursesSummaryReport', {
          schoolIds,
          courseIds,
        })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          toast('Error while fetching courses and schools. Please try again.', {
            type: 'error',
          });

          return reject();
        });
    });
  };
}

export function getCourseSnapshots(courseIds) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/multiCourseReports/getCourseSnapshots', {
          courseIds,
        })
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          toast('Error while fetching course snapshots. Please try again.', {
            type: 'error',
          });

          return reject();
        });
    });
  };
}

export function getCourseConfigForUser() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/multiCourseReports/getCourseConfigForUser')
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          toast(
            'Error while fetching course config for user. Please try again.',
            {
              type: 'error',
            },
          );

          return reject();
        });
    });
  };
}
